import { render, staticRenderFns } from "./RewardButton.vue?vue&type=template&id=1481fed6&scoped=true"
import script from "./RewardButton.vue?vue&type=script&lang=ts"
export * from "./RewardButton.vue?vue&type=script&lang=ts"
import style0 from "./RewardButton.vue?vue&type=style&index=0&id=1481fed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1481fed6",
  null
  
)

export default component.exports